<template>
  <div class="feature-card-power-feature-card" v-bind:class="rootClassName">
    <h2 class="feature-card-power-text">{{ title }}</h2>
    <span class="feature-card-power-text1">{{ description }}</span>
  </div>
</template>

<script>
export default {
  name: 'FeatureCardPower',
  props: {
    description: {
      type: String,
      default:
        'Our power plants are spread all across the United States to ensure that everyone can have access to reliable, cheap electricity.',
    },
    title: {
      type: String,
      default: 'Power',
    },
    rootClassName: String,
  },
}
</script>

<style scoped>
.feature-card-power-feature-card {
  width: 100%;
  display: flex;
  padding: 32px;
  align-items: center;
  flex-direction: column;
}
.feature-card-power-text {
  font-style: normal;
  margin-top: var(--dl-space-space-unit);
  text-align: center;
  font-weight: 500;
  margin-bottom: var(--dl-space-space-unit);
}
.feature-card-power-text1 {
  color: var(--dl-color-gray-700);
  text-align: center;
}

@media(max-width: 1200px) {
  .feature-card-power-text1 {
    color: var(--dl-color-gray-black);
  }
}
</style>
